import BoltBanner from "../boltClone/BoltBanner";
import BoltOwnCode from "../boltClone/BoltOwnCode";
import { lazy, Suspense } from "react";

const LyftTeamlogo = lazy(() => import("../LyftClone/LyftTeamlogo"));
const BoltSuperlative = lazy(() => import("../boltClone/BoltSuperlative"));
const BoltNeed = lazy(() => import("../boltClone/BoltNeed"));
const BoltDrive = lazy(() => import("../boltClone/BoltDrive"));
const BoltJourney = lazy(() => import("../boltClone/BoltJourney"));
const BoltBuild = lazy(() => import("../boltClone/BoltBuild"));
const BoltForYou = lazy(() => import("../boltClone/BoltForYou"));
const BoltDevelopement = lazy(() => import("../boltClone/BoltDevelopement"));
const BoltCustom = lazy(() => import("../boltClone/BoltCustom"));
const BoltSmart = lazy(() => import("../boltClone/BoltSmart"));
const BoltWhiteLabel = lazy(() => import("../boltClone/BoltWhiteLabel"));
const BoltGen = lazy(() => import("../boltClone/BoltGen"));
const BoltGlobal = lazy(() => import("../boltClone/BoltGlobal"));
const ShuttleAppreciation = lazy(() => import("../../shuttle_software/ShuttleAppreciation"));
const TaxiFaq = lazy(() => import("../../taxiDispatchSoftware/TaxiFaq"));

const bannerData = {
  class: "bolt-banner",
  titlePart1: "Free Now Clone App",
  titlePart2: "Development Company",
  description: "Leading experts in creating scalable, secure, and fully customizable taxi booking apps tailored for seamless user experiences.",
  image: "/assets/home/bolt-banner.webp",
  btn1: "contact us",
  btn2: "watch demo",
  counter1: {
    number: "2000+",
    text: "Apps Launched"
  },
  counter2: {
    number: "100+",
    text: "Expert Developers"
  },
  counter3: {
    number: "250+",
    text: "Happy Clients"
  },
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "free now Clone App",
        slug: ""
      },
    ]
  }
};

const OwnCodeData = {
  box1: {
    image: "/assets/home/bolt-own-code-1.webp",
    title: "Own the Entire Source Code",
  },
  box2: {
    image: "/assets/home/bolt-own-code-2.webp",
    title: "Outstanding UI & Superior UX",
  },
  box3: {
    image: "/assets/home/bolt-own-code-3.webp",
    title: "Fully Customized Solution",
  },
  box4: {
    image: "/assets/home/bolt-own-code-4.webp",
    title: "Next-Level Features",
  },
}

const superlativeData = {
  titlePart1: "Why",
  titlePart2: "Free Now Clone App",
  titlePart3: "Superlative For Taxi Booking Businesses?",
  description1: "American passengers demand convenience, trust, and speed in today's fast-paced urban mobility scene. That’s where the Free Now Clone app by Mobility Infotech leads the pack. Designed specifically for the USA's competitive ride-hailing landscape, our comprehensive solution offers everything required to build and scale a thriving taxi business. Whether you're a visionary entrepreneur launching a new ride-hailing startup or a seasoned fleet operator modernizing your operations, our Free Now Clone app merges advanced technology with intuitive usability. From smart ride‑matching and real-time GPS tracking to automated billing and secure multi‑payment support, it delivers an efficient and satisfying experience for both riders and drivers.",
  description2: "What truly sets this solution apart isn’t just its tech power—it’s the market‑ready advantage it gives you. With white‑label branding, regional surge pricing, city‑specific promos, and multilingual support, the Free Now Clone adapts quickly across U.S. regions. Its scalable foundation ensures your business evolves smoothly as it grows. Robust, reliable technology is essential in a competitive U.S. marketplace. Choose Mobility Infotech’s Free Now Clone app—your faster, smarter, and scalable path to success in the ride‑hailing industry.",
}

const needData = {
  titlePart1: "Taxi",
  titlePart2: "App Development Solutions",
  titlePart3: "for Every Business Need",
  description: "Mobility Infotech delivers cutting-edge taxi app solutions tailored to meet diverse business needs, revolutionizing USA’s transportation landscape with innovative, efficient, and user-friendly ride-hailing experiences for all.",
  boxes: [
    {
      image: "/assets/home/bolt-need-1.webp",
      title: "On-Demand Taxi Booking Apps",
      para: "Deliver real‑time ride­‑booking with immediate driver assignment, tracking, and secure checkout. Ideal for startups and urban mobility operators across U.S. cities.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-2.webp",
      title: "Ride-sharing or Carpooling Apps",
      para: "Encourage affordable and eco‑friendly commutes with smart matching, route optimization, and fare splitting for cost‑conscious U.S. riders.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-3.webp",
      title: "Corporate Taxi Booking Apps",
      para: "Help American businesses manage employee transportation through centralized scheduling, real‑time tracking, and consolidated invoicing.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-4.webp",
      title: "Rental or Hourly Taxi Booking Apps",
      para: "Enable passengers to book rides hourly or for out‑of‑town travel. Great for U.S. professionals, tourists, and frequent travelers.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-5.webp",
      title: "Luxury & Limousine Booking Apps",
      para: "Cater to premium clientele with real‑time chauffeur visibility, exclusive car choices, and luxury‑level support for events or executive travel.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-6.webp",
      title: "Bike Taxi Booking Apps",
      para: "Address urban congestion with economical two‑wheeler options for solo commuters or last‑mile deliveries in major American cities.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-7.webp",
      title: "White-Label Taxi Booking Apps",
      para: "Launch your branded platform quickly with custom design, logo, and feature integration to match your business identity.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-8.webp",
      title: "Airport Transfer Taxi Apps",
      para: "Simplify airport travel with flight‑linked scheduling, driver alerts, and dedicated pickup zones at U.S. airports.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-9.webp",
      title: "Electric Vehicle (EV) Taxi Apps",
      para: "Support sustainability with EV integration, green‑routing features, and charging point locators suited for America’s growing eco‑fleet.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-10.webp",
      title: "Paratransit or Accessible Taxi Apps",
      para: "Fulfill ADA‑compliance with app and vehicle features tailored for riders with mobility challenges across the United States.",
      btn: "Request a free demo",
    },
  ],
}

const driveData = {
  titlePart1: "Drive Your Success with America’s ",
  titlePart2: "Leading Taxi App Development Experts",
  description: "Embrace innovation with our advanced ride‑hailing app development and see the results:",
  image: "/assets/home/bolt-drive.webp",
  vector: "/assets/home/bolt-drive-vec.webp",
  boxes: [
    {
      image: "/assets/home/drive-circle-1.webp",
      title: "60% Rise in Ride Bookings Per Quarter",
    },
    {
      image: "/assets/home/drive-circle-2.webp",
      title: "45% Reduction in Average Pickup Times",
    },
    {
      image: "/assets/home/drive-circle-3.webp",
      title: "35% Lower Operational Costs",
    },
    {
      image: "/assets/home/drive-circle-4.webp",
      title: "44% Boost in Revenue Generation",
    },
    {
      image: "/assets/home/drive-circle-5.webp",
      title: "75% Rise in Customer Loyalty and Repeat Rides",
    },
    {
      image: "/assets/home/drive-circle-6.webp",
      title: "58% Growth in Positive Customer Feedback Every Quarter",
    },
  ],
}

const journeyData = {
  titlePart1: "Our Taxi App Development Process That",
  titlePart2: "Drives Your Business Forward",
  description: "Planning to launch a Free Now‑style app? Here's a simplified view of how it works to ensure smooth operations and high user satisfaction:",
  image: "/assets/home/bolt-journey.webp",
  vector: "/assets/home/bolt-journey-vec.webp",
}

const buildData = {
  titlePart1: "We Build Taxi Booking Apps",
  titlePart2: "Using Advanced Features",
  description: "At Mobility Infotech, our Free Now Clone app integrates cutting‑edge technology to enhance usability, safety, and fleet performance. Here are the innovations that power our system:",
  btn: "more features",
  tabs: [{
    title: "AI-Powered Route Optimization",
    description: "Use AI‑driven routing to deliver time‑saving, efficient trips based on real‑time traffic across American cities.",
    icon: "/assets/home/bolt-build-icon-1.webp",
    image: "/assets/home/bolt-build-1.webp",
  },
  {
    title: "IoT for Vehicle Tracking",
    description: "Enable live vehicle tracking, fleet monitoring, and predictive maintenance to minimize breakdowns.",
    icon: "/assets/home/bolt-build-icon-2.webp",
    image: "/assets/home/bolt-build-2.webp",
  },
  {
    title: "Chatbots for Customer Support",
    description: "24/7 automated customer assistance for booking, cancellations, and inquiries.",
    icon: "/assets/home/bolt-build-icon-3.webp",
    image: "/assets/home/bolt-build-3.webp",
  },
  {
    title: "Blockchain for Secure Payments",
    description: "Implement tamper‑proof, blockchain‑driven transactions to maximize payment transparency and safety.",
    icon: "/assets/home/bolt-build-icon-4.webp",
    image: "/assets/home/bolt-build-4.webp",
  },
  {
    title: "Intelligent Driver Matching System",
    description: "Match riders with top‑rated nearby drivers using AI‑driven logic to enhance satisfaction and reduce wait times.",
    icon: "/assets/home/bolt-build-icon-5.webp",
    image: "/assets/home/bolt-build-5.webp",
  },
  {
    title: "AR for Enhanced Navigation",
    description: "Use AR tools to help drivers navigate unfamiliar roads with ease and accuracy.",
    icon: "/assets/home/bolt-build-icon-6.webp",
    image: "/assets/home/bolt-build-6.webp",
  },],
}

const forYouData = {
  newClass: "bolt-for-you",
  text: "Mobility Infotech Will",
  text2: "Build a White-Label Taxi Booking",
  title: "App Just for You",
  btn: "BEGIN NOW!",
}

const developementData = {
  titlePart1: "Key Features of Our ",
  titlePart2: "Free Now Clone App ",
  titlePart3: "Development",
  description: "Partner with Mobility Infotech to build a secure, robust, and scalable taxi platform tailored for U.S. transportation demands.",
  btn: "Get Started",
  customer: {
    image: "/assets/home/bolt-developement-1.webp",
    title: "Customer App",
    description: "An intuitive and user-friendly platform that enables American passengers to book rides quickly, track drivers live, and enjoy flexible, secure payment options.",
    boxes: [
      {
        title: "Seamless Ride Booking",
        desc: "Users can easily book rides with just a few taps through an intuitive interface designed for speed and convenience across all mobile and web platforms."
      },
      {
        title: "Multiple Payment Options",
        desc: "Customers can pay using credit/debit cards, PayPal, digital wallets, or cash, offering flexibility and convenience for diverse user preferences."
      },
      {
        title: "Ride Sharing Availability",
        desc: "Riders can share trip details live with friends and family, ensuring greater peace of mind and safety throughout the entire journey."
      },
      {
        title: "Schedule a Rides",
        desc: "Passengers can schedule rides for future needs like airport pickups, meetings, or errands, offering flexibility and planning convenience."
      },
      {
        title: "Live Driver Tracking",
        desc: "Track your assigned driver in real time with accurate GPS navigation and estimated arrival times based on live traffic conditions."
      },
      {
        title: "Push Notifications",
        desc: "Receive timely updates on booking confirmations, driver arrivals, ongoing ride status, and personalized promotional offers directly on your device."
      },
    ]
  },
  driver: {
    image: "/assets/home/bolt-developement-2.webp",
    title: "Driver App",
    description: "A powerful tool built for American drivers to manage trips, optimize routes, communicate with riders, and maximize daily earnings efficiently.",
    boxes: [
      {
        title: "Direct Calling",
        desc: "Drivers can directly contact passengers to clarify pickup details and ensure smooth coordination without any third-party communication barrier."
      },
      {
        title: "Optimized Route Navigation",
        desc: "Built-in traffic-aware GPS guides drivers through the most efficient routes, reducing delays and fuel consumption."
      },
      {
        title: "Start & End Ride Tracking",
        desc: "Easily begin and conclude rides with a single tap, ensuring accurate billing and smoother workflow for drivers."
      },
      {
        title: "Built-In Help & Support",
        desc: "Access real-time support for any technical or trip-related issues directly from the app to ensure uninterrupted service."
      },
      {
        title: "Earnings Dashboard",
        desc: "View comprehensive earnings reports by day, week, or month, along with trip history and payout status in real time."
      },
      {
        title: "In-App Chat",
        desc: "Chat securely with passengers for quick coordination without disclosing personal contact information."
      },
    ]
  },
  dispatcher: {
    image: "/assets/home/bolt-developement-3.webp",
    title: "Dispatcher Dashboard",
    description: "A robust backend control panel for fleet managers to assign rides, track vehicle movement, and monitor service performance in real time.",
    boxes: [
      {
        title: "Automatic Dispatching",
        desc: "Automatically assign the nearest available driver using smart geo-location logic to minimize passenger wait times and maximize fleet utilization."
      },
      {
        title: "Booking Management",
        desc: "Monitor and manage all active, pending, and completed bookings from a single, streamlined dashboard."
      },
      {
        title: "Live Fleet Tracking",
        desc: "Track every vehicle on the road with GPS-based insights for safety, time management, and better operational control."
      },
      {
        title: "Push Alerts for Dispatch",
        desc: "Send instant ride alerts, notifications, and assignment changes to drivers with minimal delay for optimized response times."
      },
      {
        title: "Smart Route Planning",
        desc: "Plan and update driver routes using real-time traffic data to reduce idle time and fuel costs."
      },
      {
        title: "Complete Transaction History",
        desc: "Review and export transaction logs and ride data to maintain transparency and simplify accounting."
      },
    ]
  },
  admin: {
    image: "/assets/home/bolt-developement-4.webp",
    title: "Admin Panel",
    description: "Your central control center to monitor every aspect of your taxi app—from operations and finance to user management and promotions.",
    boxes: [
      {
        title: "Driver Supervision",
        desc: "Add, verify, or suspend drivers from a single admin screen to maintain safety, compliance, and service quality."
      },
      {
        title: "In-Depth Analytics",
        desc: "Get complete insights into business performance with data on ride volume, customer behavior, driver ratings, and more."
      },
      {
        title: "Integrated Payment Management",
        desc: "Manage customer payments, driver payouts, and transaction histories seamlessly, with full control over refunds and commission rules."
      },
      {
        title: "Promo & Loyalty Management",
        desc: "Design and run promotional campaigns, referral bonuses, and loyalty rewards to boost user retention and app engagement."
      },
      {
        title: "Real-Time Admin Chat",
        desc: "Engage in direct conversations with support teams or drivers for quick resolution of issues or clarification."
      },
      {
        title: "Booking Oversight",
        desc: "Monitor all ride bookings, make manual interventions when necessary, and ensure overall service quality in real-time."
      },
    ]
  },
}

const customData = {
  titlePart1: "Tailored Taxi App Solutions",
  titlePart2: "for Every Industry",
  description: "The Free Now Clone adapts to diverse business use-cases—making it the ideal taxi app for companies across various American sectors.",
  slides: [
    {
      image: "/assets/home/bolt-custom-slide-1.webp",
      title: "Corporate Transportation Providers",
      desc: "Help enterprises manage employee transportation through scheduled rides, corporate billing, and detailed usage reporting.",
    },
    {
      image: "/assets/home/bolt-custom-slide-2.webp",
      title: "Taxi App for fleet Businesses",
      desc: "Run smarter operations with centralized fleet management, real-time dispatching, and performance tracking for drivers and vehicles.",
    },
    {
      image: "/assets/home/bolt-custom-slide-3.webp",
      title: "Events Transportation Providers",
      desc: "Manage transport for large events, weddings, or conferences with advanced scheduling, guest tracking, and real-time updates.",
    },
    {
      image: "/assets/home/bolt-custom-slide-4.webp",
      title: "School And College Operation",
      desc: "Improve student safety with GPS-enabled tracking, secure pickup notifications, and guardian alerts for educational institutions.",
    },
    {
      image: "/assets/home/bolt-custom-slide-5.webp",
      title: "Tour & Travel Operation",
      desc: "Enhance tourist group logistics with trip planning, itinerary syncing, and live vehicle tracking features.",
    },
  ]
}

const smartData = {
  titlePart1: "Where",
  titlePart2: "Smart Mobility Meets",
  titlePart3: "Profitable App Business Models",
  description: "Generate strong ROI through strategic monetization features integrated within the platform.",
  boxes: [
    {
      image: "/assets/home/bolt-smart-1.webp",
      title: "Trip Commissions",
      desc: "Charge a commission on every completed ride and customize rates for different cities or service categories.",
    },
    {
      image: "/assets/home/bolt-smart-2.webp",
      title: "Surge Pricing",
      desc: "Automatically adjust fare rates during high-demand periods to increase revenue and balance rider-driver availability.",
    },
    {
      image: "/assets/home/bolt-smart-3.webp",
      title: "Reports and Analytics",
      desc: "Offer premium access to advanced data insights and analytics dashboards for business clients and large fleet owners.",
    },
    {
      image: "/assets/home/bolt-smart-4.webp",
      title: "Cancellation Fees",
      desc: "Minimize operational losses by charging cancellation fees for last-minute ride dropouts or no-shows.",
    },
    {
      image: "/assets/home/bolt-smart-5.webp",
      title: "Leasing to Drivers",
      desc: "Generate revenue by leasing the platform or fleet vehicles to registered drivers on a daily, weekly, or monthly basis.",
    },
    {
      image: "/assets/home/bolt-smart-6.webp",
      title: "Brand Advertising",
      desc: "Offer in-app ad space or sponsored listings to third-party brands, local businesses, or event organizers.",
    },
  ]
}

const WhiteLabelData = {
  title: "Develop Your White-Label Taxi Dispatch App with Mobility Infotech",
  description: "With over 10 years of experience and state-of-the-art technology, Mobility Infotech helps you launch a powerful taxi app tailored to meet the needs of the USA market.",
  boxes: [
    {
      image: "/assets/home/bolt-white-1.webp",
      title: "White-Label Solution",
      desc: "Launch a branded app with advanced features to represent your business.",
    },
    {
      image: "/assets/home/bolt-white-2.webp",
      title: "Ready To Use",
      desc: "Get your app up and running in just 3 days.",
    },
    {
      image: "/assets/home/bolt-white-3.webp",
      title: "Highly Scalable",
      desc: "Effortlessly expand your operations city by city or across the nation.",
    },
    {
      image: "/assets/home/bolt-white-4.webp",
      title: "Seamless Integration",
      desc: "Easily connect with your existing systems for smooth operations.",
    },
    {
      image: "/assets/home/bolt-white-5.webp",
      title: "Fully Customizable",
      desc: "Design every feature to align perfectly with your business goals.",
    },
    {
      image: "/assets/home/bolt-white-6.webp",
      title: "User-Friendly Interface",
      desc: "Deliver a seamless experience for drivers and passengers alike.",
    },
  ]
}

const genData = {
  titlePart1: "Next-Gen",
  titlePart2: "Taxi App Development",
  titlePart3: "Company Driving Innovation",
  description: "Mobility Infotech empowers your ride-hailing startup with future-ready tech:",
  boxes: [
    {
      image: "/assets/home/lyft-minimum-1.webp",
      title: "Automate dispatch from admin panel.",
    },
    {
      image: "/assets/home/lyft-minimum-2.webp",
      title: "GPS-based real-time driver tracking.",
    },
    {
      image: "/assets/home/lyft-minimum-3.webp",
      title: "Monitor operations live.",
    },
    {
      image: "/assets/home/lyft-minimum-4.webp",
      title: "Access analytics for better decision-making.",
    },
    {
      image: "/assets/home/lyft-minimum-5.webp",
      title: "Integrate multiple payment gateways.",
    },
    {
      image: "/assets/home/lyft-minimum-6.webp",
      title: "Enable rider ratings and trip reviews.",
    },
  ],
}

const globalData = {
  titlePart1: "Proven Impact from",
  titlePart2: "Our Taxi App",
  titlePart3: "Development",
  counter1: {
    number: "70",
    text: "Increase in Potential ROI",
  },
  counter2: {
    number: "64",
    text: "Increase in Customer Satisfaction",
  },
  counter3: {
    number: "40",
    text: "Increase in Bookings",
  },
  counter4: {
    number: "20",
    text: "Reduction in Maintenance Cost",
  },
}

const faqData = [
  {
    id: "0",
    question: "01. What is Mobility Infotech’s Free Now Clone App?",
    answer: "Mobility Infotech’s Free Now Clone is a fully white-labeled, customizable ride-hailing app built specifically for the U.S. market, offering top-tier tech, user-friendly design, and scalable operations.",
  },
  {
    id: "1",
    question: "02. Why choose Mobility Infotech for app development?",
    answer: "We combine a decade of experience with advanced technologies, 24/7 support, fast deployment, and a commitment to delivering tailor-made mobility solutions that evolve with your business needs.",
  },
  {
    id: "2",
    question: "03. How customizable is the app?",
    answer: "Our app is fully customizable—from UI design and branding to feature modules, pricing structures, payment gateways, and third-party integrations—ensuring it aligns seamlessly with your unique business model.",
  },
  {
    id: "3",
    question: "04. Is post-launch support available?",
    answer: "Yes, we provide complete post-launch services including regular updates, security patches, system maintenance, feature upgrades, and real-time tech support to ensure long-term app stability and growth.",
  },
  {
    id: "4",
    question: "05. How fast can the app go live?",
    answer: "With our pre-built architecture and agile deployment process, your ride-hailing app can be up and running in as little as 3 days, ready for immediate market launch.",
  },
  {
    id: "5",
    question: "06. Can it integrate with my existing systems?",
    answer: "Absolutely. Our solution seamlessly integrates with your current CRM, ERP, payment processors, accounting software, and fleet dispatch systems for a unified operational experience.",
  },
  {
    id: "6",
    question: "07. What tech is included?",
    answer: "Our platform incorporates cutting-edge technologies like AI-powered route optimization, IoT vehicle tracking, blockchain-based payments, AR-based driver ID verification, chatbots for support, and more.",
  },
  {
    id: "7",
    question: "08. How secure is the app?",
    answer: "We follow enterprise-grade security protocols, including end-to-end encryption, blockchain-backed payment verification, secure login, GDPR compliance, and real-time fraud detection to safeguard user data and transactions.",
  },
];

export default function FreeNow() {
  return (
    <>
      <BoltBanner data={bannerData} />
      <BoltOwnCode data={OwnCodeData} />

      <Suspense fallback={null}>
        <LyftTeamlogo heading={true} newClass="bolt-clone-team" />
        <BoltSuperlative data={superlativeData} />
        <BoltNeed data={needData} />
        <BoltDrive data={driveData} />
        <BoltJourney data={journeyData} />
        <BoltBuild data={buildData} />
        <BoltForYou data={forYouData} />
        <BoltDevelopement data={developementData} />
        <BoltCustom data={customData} />
        <BoltSmart data={smartData} />
        <BoltWhiteLabel data={WhiteLabelData} />
        <BoltGen data={genData} />
        <BoltGlobal data={globalData} />
        <ShuttleAppreciation />
        <div className="zip-faq-fixer">
          <TaxiFaq faqData={faqData} />
        </div>
      </Suspense>
    </>
  )
}
